
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State } from 'react-powerplug'
import FormFieldCombinedInput from './form-field-combined-input'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfieldcombinedinput"
    }}>{`FormFieldCombinedInput`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "combined-input-field"
    }}>{`Combined input field`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For single input forms, such as search.`}</p>
    <Playground __position={1} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      {...state}\n      buttonLabel=\"Button\"\n      id=\"combined\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldCombinedInput {...state} buttonLabel="Button" id='combined' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={2} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      {...state}\n      buttonLabel=\"Button\"\n      id=\"validation\"\n      error=\"Notice\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldCombinedInput {...state} buttonLabel="Button" id='validation' error="Notice" labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "combined-input-field-adjacent"
    }}>{`Combined input field (adjacent)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For single input forms, such as search.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <Playground __position={4} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      {...state}\n      adjacent\n      buttonLabel=\"Button\"\n      id=\"combined-adjacent\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldCombinedInput {...state} adjacent buttonLabel="Button" id='combined-adjacent' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
      </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "combined-input-field-inverse"
    }}>{`Combined input field (inverse)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For single input forms, such as search.`}</p>
    <Playground __position={6} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      {...state}\n      id=\"combined-inverse\"\n      buttonLabel=\"Button\"\n      inverse\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldCombinedInput {...state} id='combined-inverse' buttonLabel="Button" inverse labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
      </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "combined-input-field-inverse-adjacent"
    }}>{`Combined input field (inverse, adjacent)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For single input forms, such as search.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <Playground __position={8} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      adjacent\n      {...state}\n      id=\"combined-inverse\"\n      buttonLabel=\"Button\"\n      inverse\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldCombinedInput adjacent {...state} id='combined-inverse' buttonLabel="Button" inverse labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
      </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "combined-input-field-slim"
    }}>{`Combined input field (slim)`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`For single input forms. Use where inputs are nested or constrained by layout.`}</p>
    <Playground __position={10} __code={'<State initial={{ value: \'Text value\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      {...state}\n      id=\"combined-slim\"\n      buttonLabel=\"Button\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      slim\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} mdxType="Playground">
  <State initial={{
        value: 'Text value'
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldCombinedInput {...state} id='combined-slim' buttonLabel="Button" labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} slim placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "combined-input-field-slim-adjacent"
    }}>{`Combined input field (slim, adjacent)`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`For single input forms. Use where inputs are nested or constrained by layout.`}</p>
    <Playground __position={12} __code={'<State initial={{ value: \'Text value\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      adjacent\n      {...state}\n      id=\"combined-slim\"\n      buttonLabel=\"Button\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      slim\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} mdxType="Playground">
  <State initial={{
        value: 'Text value'
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldCombinedInput adjacent {...state} id='combined-slim' buttonLabel="Button" labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} slim placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "combined-input-field-slim-inverse"
    }}>{`Combined input field (slim, inverse)`}</h2>
    <h3 {...{
      "id": "description-6"
    }}>{`Description`}</h3>
    <p>{`For single input forms. Use where inputs are nested or constrained by layout.`}</p>
    <Playground __position={14} __code={'<State initial={{ value: \'Text value\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      {...state}\n      buttonLabel=\"Button\"\n      labelText=\"Label\"\n      id=\"combined-slim-inverse\"\n      inverse\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      slim\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <State initial={{
        value: 'Text value'
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldCombinedInput {...state} buttonLabel="Button" labelText="Label" id='combined-slim-inverse' inverse maxLength={30} onChange={e => setState({
          value: e.target.value
        })} slim placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "combined-input-field-slim-inverse-adjacent"
    }}>{`Combined input field (slim, inverse, adjacent)`}</h2>
    <h3 {...{
      "id": "description-7"
    }}>{`Description`}</h3>
    <p>{`For single input forms. Use where inputs are nested or constrained by layout.`}</p>
    <Playground __position={16} __code={'<State initial={{ value: \'Text value\' }}>\n  {({ state, setState }) => (\n    <FormFieldCombinedInput\n      adjacent\n      {...state}\n      buttonLabel=\"Button\"\n      labelText=\"Label\"\n      id=\"combined-slim-inverse\"\n      inverse\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      slim\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldCombinedInput
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <State initial={{
        value: 'Text value'
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldCombinedInput adjacent {...state} buttonLabel="Button" labelText="Label" id='combined-slim-inverse' inverse maxLength={30} onChange={e => setState({
          value: e.target.value
        })} slim placeholder='Text placeholder' mdxType="FormFieldCombinedInput" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormFieldCombinedInput} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;